import api from "../index";
import { configurationVariables } from "../../environment/index";

const idHotsite = parseInt(configurationVariables.IdHotsite);

export const getCartoes = async (idCliente) => {
  try {
    const response = await api.get(
      `/CartaoCreditoCliente/GetByIdCliente?idCliente=${idCliente}`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao buscar cartões:", error);
    throw error;
  }
};

export const desativaAtivaByID = async (idCliente, idCartao) => {
  try {
    const response = await api.post(
      `/CartaoCreditoCliente/DesativaAtivaByID?idCliente=${idCliente}&idCartao=${idCartao}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao ativar/desativar cartão:", error);
    throw error;
  }
};
